/** Messages entre le fil principal et le worker MediaPipe (`landmarker.worker.ts`). PUR. */
import type { Delegate } from './delegate';

export type Model = 'face' | 'hand';

export type ToWorker =
  | { readonly type: 'init'; readonly model: Model; readonly delegate: Delegate }
  | {
      readonly type: 'detect';
      readonly id: number;
      /** Pixels RGBA (transférés, pas copiés) ; rendus avec la réponse. */
      readonly pixels: ArrayBuffer;
      readonly width: number;
      readonly height: number;
      readonly t: number;
    };

export type FromWorker =
  | { readonly type: 'ready' }
  | { readonly type: 'init-error'; readonly message: string }
  | {
      readonly type: 'result';
      readonly id: number;
      readonly result: unknown;
      readonly pixels: ArrayBuffer;
      /** Durée de l'inférence MediaPipe seule (ms), hors transport. */
      readonly inferenceMs: number;
    }
  | {
      readonly type: 'detect-error';
      readonly id: number;
      readonly message: string;
      readonly pixels: ArrayBuffer;
    };

export const describeError = (e: unknown): string =>
  e instanceof Error ? `${e.name} : ${e.message}` : String(e);
